'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LiveAddonProduct = undefined;

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _slicedToArray2 = require('babel-runtime/helpers/slicedToArray');

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _get2 = require('babel-runtime/helpers/get');

var _get3 = _interopRequireDefault(_get2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _assign = require('babel-runtime/core-js/object/assign');

var _assign2 = _interopRequireDefault(_assign);

var _sagaTools = require('@classpass/saga-tools');

var _reduxForm = require('redux-form');

var _effects = require('redux-saga/effects');

var _Base = require('derivers/Base64');

var _Base2 = _interopRequireDefault(_Base);

var _bound = require('redux/saga/entities/bound');

var _selectors = require('redux/saga/selectors');

var _cart = require('redux/modules/cart');

var _msas = require('constants/msas');

var _helpers = require('redux/saga/helpers');

var _Banners = require('features/Banners/Banners.reducer');

var _isMobile = require('helpers/isMobile');

var _optimizely = require('helpers/optimizely');

var _utmValues = require('helpers/utmValues');

var utmValues = _interopRequireWildcard(_utmValues);

var _page = require('redux/modules/page');

var _GoogleTagManager = require('components/GoogleTagManager/GoogleTagManager');

var _LiveProduct2 = require('./LiveProduct');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getGTMObjectForAddon = function getGTMObjectForAddon(responseFromApi, userSubscription, cart) {
  var msaId = userSubscription.msa.id;
  var msaAlias = (0, _msas.msaIdToAlias)(msaId);
  return {
    giftRedemption: false,
    planCode: userSubscription.plan.plan_code,
    purchasePlanId: userSubscription.plan.id,
    taxAmount: cart.taxTotal,
    purchaseTransactionId: userSubscription.id,
    msaId: msaId,
    msaName: msaAlias,
    currency: responseFromApi.currencyCode,
    digitalPlanCode: responseFromApi.name,
    digitalPurchasePlanId: responseFromApi.planId
  };
};

var LiveAddonProduct = exports.LiveAddonProduct = function (_LiveProduct) {
  (0, _inherits3.default)(LiveAddonProduct, _LiveProduct);

  function LiveAddonProduct() {
    (0, _classCallCheck3.default)(this, LiveAddonProduct);
    return (0, _possibleConstructorReturn3.default)(this, (LiveAddonProduct.__proto__ || (0, _getPrototypeOf2.default)(LiveAddonProduct)).apply(this, arguments));
  }

  (0, _createClass3.default)(LiveAddonProduct, null, [{
    key: 'shouldActivate',
    value: function shouldActivate(params) {
      return !!params.encodedLiveAddonId && !params.encodedStudioPlanId;
    }
  }, {
    key: 'loadPurchaseData',
    value: /*#__PURE__*/_regenerator2.default.mark(function loadPurchaseData(client, _ref) {
      var encodedLiveAddonId = _ref.encodedLiveAddonId;

      var livePlanId, userId, _ref2, _ref3, plan;

      return _regenerator2.default.wrap(function loadPurchaseData$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              livePlanId = _Base2.default.decodeNumber(encodedLiveAddonId);
              _context.next = 3;
              return (0, _effects.select)(_selectors.userId);

            case 3:
              userId = _context.sent;
              _context.next = 6;
              return (0, _effects.all)([(0, _effects.call)(_sagaTools.fetchEntityIfNeeded, _bound.livePlanById, [client, livePlanId]), (0, _effects.call)(_sagaTools.fetchEntityIfNeeded, _bound.subscription, [client, userId]), (0, _effects.put)((0, _reduxForm.change)('purchase', 'livePlanId', livePlanId)), (0, _effects.put)((0, _page.useReducedNavigation)(true))]);

            case 6:
              _ref2 = _context.sent;
              _ref3 = (0, _slicedToArray3.default)(_ref2, 1);
              plan = _ref3[0];
              _context.next = 11;
              return (0, _get3.default)(LiveAddonProduct.__proto__ || (0, _getPrototypeOf2.default)(LiveAddonProduct), 'loadLivePurchaseData', this).call(this, client, plan);

            case 11:
            case 'end':
              return _context.stop();
          }
        }
      }, loadPurchaseData, this);
    })
  }, {
    key: 'postPurchase',
    value: /*#__PURE__*/_regenerator2.default.mark(function postPurchase(result) {
      var queryString, isWebviewDevice;
      return _regenerator2.default.wrap(function postPurchase$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              queryString = window.location.search;
              _context2.next = 3;
              return (0, _effects.call)(_isMobile.isWebview, queryString);

            case 3:
              isWebviewDevice = _context2.sent;
              _context2.next = 6;
              return (0, _effects.put)((0, _Banners.addSuccessNotification)('All set! Your ClassPass Live subscription has been successfully added.', {
                timeout: 0
              }));

            case 6:
              _context2.next = 8;
              return (0, _effects.call)(LiveAddonProduct.trackPurchaseSuccess, result);

            case 8:
              if (isWebviewDevice) {
                _context2.next = 11;
                break;
              }

              _context2.next = 11;
              return (0, _effects.call)(_helpers.gtmSafeRedirect, '/videos');

            case 11:
            case 'end':
              return _context2.stop();
          }
        }
      }, postPurchase, this);
    })
  }, {
    key: 'submitPurchaseData',
    value: /*#__PURE__*/_regenerator2.default.mark(function submitPurchaseData(client, currentUserId, _ref4) {
      var address1 = _ref4.address1,
          address2 = _ref4.address2,
          city = _ref4.city,
          state = _ref4.state,
          country = _ref4.country,
          phone = _ref4.phone,
          postalCode = _ref4.postalCode,
          assets = _ref4.assets,
          livePlanId = _ref4.livePlanId;

      var conversion, _ref5, _ref6, purchase;

      return _regenerator2.default.wrap(function submitPurchaseData$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return (0, _effects.call)(utmValues.getForApi);

            case 2:
              conversion = _context3.sent;
              _context3.next = 5;
              return (0, _effects.all)([(0, _effects.call)(_sagaTools.fetchEntity, _bound.createLiveSubscription, [client, {
                planId: livePlanId,
                assets: assets.filter(function (asset) {
                  return asset.include;
                }).map(function (asset) {
                  return asset.assetCode;
                }),
                conversion: conversion
              }]), (0, _effects.call)(client.users.updateUserProfile, {
                contact_info: {
                  address: {
                    address1: address1,
                    address2: address2,
                    city: city,
                    state: state,
                    country: country,
                    postal_code: postalCode
                  },
                  phone: phone
                }
              })]);

            case 5:
              _ref5 = _context3.sent;
              _ref6 = (0, _slicedToArray3.default)(_ref5, 1);
              purchase = _ref6[0];
              _context3.next = 10;
              return (0, _effects.all)([(0, _effects.call)(_sagaTools.fetchEntity, _bound.userPermissions, [client, currentUserId]), (0, _effects.put)(_bound.liveSubscription.resetAction())]);

            case 10:
              return _context3.abrupt('return', purchase);

            case 11:
            case 'end':
              return _context3.stop();
          }
        }
      }, submitPurchaseData, this);
    })
  }, {
    key: 'trackPurchaseSuccess',
    value: /*#__PURE__*/_regenerator2.default.mark(function trackPurchaseSuccess(result) {
      var _ref7, _ref8, cart, userId, userSubscription, digitalPurchaseType, gtmResultMappingObject, gtmDataObject, calls;

      return _regenerator2.default.wrap(function trackPurchaseSuccess$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              _context4.next = 2;
              return (0, _effects.all)([(0, _effects.select)(_cart.selectCart), (0, _effects.select)(_selectors.userId), (0, _effects.select)(_selectors.currentSubscription)]);

            case 2:
              _ref7 = _context4.sent;
              _ref8 = (0, _slicedToArray3.default)(_ref7, 3);
              cart = _ref8[0];
              userId = _ref8[1];
              userSubscription = _ref8[2];
              digitalPurchaseType = 'addon';
              gtmResultMappingObject = getGTMObjectForAddon(result.data, userSubscription, cart);
              gtmDataObject = (0, _assign2.default)(gtmResultMappingObject, {
                event: 'cplive_purchase',
                userId: userId,
                purchaseChargeAmount: cart.debitTotal,
                digitalPurchaseType: digitalPurchaseType
              });
              calls = [(0, _effects.call)(_GoogleTagManager.trackGoogleTagManagerEvent, gtmDataObject), (0, _effects.call)(_optimizely.trackOptimizelyEvent, 'successful_cplive_purchase')];
              _context4.next = 13;
              return (0, _effects.all)(calls);

            case 13:
            case 'end':
              return _context4.stop();
          }
        }
      }, trackPurchaseSuccess, this);
    })
  }]);
  return LiveAddonProduct;
}(_LiveProduct2.LiveProduct);

LiveAddonProduct.key = 'LiveAddonProduct';